import FacebookLogin from '@greatsumini/react-facebook-login'
import { useDispatch, useSelector } from 'react-redux'
import { loginWithFacebookClean, loginWithFacebookRequest } from '../../../state/modules/login/actions'
import { useNavigate } from 'react-router-dom'
import { Box, Text, useToast } from '@chakra-ui/react'
import BlueButton from '../../buttons/button-blue'
import { useEffect, useRef } from 'react'
import { State } from '../../../state/types'

export const FacebookLoginButton = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const toast = useToast()
  const { loginFacebookSuccess } = useSelector((state: State) => state.facebookLogin)
  const hiddenButtonWrapperRef = useRef<HTMLDivElement>(null)

  const handleClick = () => {
    const button = hiddenButtonWrapperRef.current?.querySelector('button')
    button?.click()
  }

  useEffect(() => {
      if (loginFacebookSuccess === false) {
        toast({
          title: 'Error de autenticación',
          description:
            'El usuario ingresado no existe en EDUprivada. Por favor, revisá los datos o registrate si aún no tenés una cuenta. ¡Gracias!',
          status: 'error',
          duration: 2000,
          isClosable: true,
        })
      }
  
      dispatch(loginWithFacebookClean())
    }, [loginFacebookSuccess, toast])

  return (
    <Box width="full">
      <BlueButton
        variant="outline"
        width={'250px'}
        onClick={handleClick}
        leftIcon={<img src="Facebook_Logo_Primary.png" alt="Facebook Logo" width="20" />}
        style={{ marginLeft: '25px' }}
      >
        <Text size="sm" fontWeight="normal">Ingresar con Facebook</Text>
      </BlueButton>

      <Box ref={hiddenButtonWrapperRef} display="none">
        <FacebookLogin
          appId={window._env_.REACT_APP_FACEBOOK_APP_ID!}
          onSuccess={(response: { accessToken: string; userID: string }) => {
            dispatch(loginWithFacebookRequest({ accessToken: response.accessToken, navigate }))
          }}
          onFail={(error: unknown) => {
            console.error('Facebook login failed:', error)
          }}
          onProfileSuccess={(profile: any) => {
            console.log('Facebook profile:', profile)
          }}
        />
      </Box>
    </Box>
  )
}